import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import { FilePreview } from '@wdx/shared/infrastructure/file-io';
import { MIMETypeToFileFormat } from '@wdx/shared/utils';
import { FeatureSvg } from '../../../../../models/svg.model';

@Component({
    selector: 'clmi-document-preview-pane',
    templateUrl: './document-preview-pane.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DocumentPreviewPaneComponent {
    @Input() isLoading: boolean;
    @Input() hasError: boolean;
    @Input() filePreview: FilePreview;

    @Output() download = new EventEmitter();

    readonly FEATURE_SVG = FeatureSvg;
    readonly MIME_TYPES = MIMETypeToFileFormat;

    onDownload(): void {
        this.download.emit();
    }
}
